import React from 'react';
import { Search } from 'lucide-react';
interface TopNavProps {
  activeSection: 'documentation' | 'api-reference';
  onSectionChange: (section: 'documentation' | 'api-reference') => void;
}
export function TopNav({
  activeSection,
  onSectionChange
}: TopNavProps) {
  return <header className="w-full bg-white border-b border-gray-200 px-6 py-3 flex justify-between items-center sticky top-0 z-20 shadow-sm" data-id="element-289">
      <div className="flex items-center space-x-8" data-id="element-290">
        <div className="flex items-center" data-id="element-291">
          <img src="https://cdn.magicpatterns.com/uploads/5icnLANuoMbRioXHmJAYNk/Paysys_Logo.png" alt="Paysys Logo" className="h-8 object-contain mr-3" data-id="element-292" />
          <span className="text-gray-900 font-semibold text-lg hidden md:block border-l border-gray-300 pl-3" data-id="element-293">
            Developer Portal
          </span>
        </div>

        <nav className="hidden lg:flex items-center space-x-6 text-sm font-medium" data-id="element-294">
          <button onClick={() => onSectionChange('documentation')} className={`transition-colors ${activeSection === 'documentation' ? 'text-[#0B5FA5]' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-295">
            Documentation
          </button>
          <button onClick={() => onSectionChange('api-reference')} className={`transition-colors ${activeSection === 'api-reference' ? 'text-[#0B5FA5]' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-296">
            API Reference
          </button>
        </nav>
      </div>

      <div className="flex items-center space-x-4" data-id="element-297">
        <div className="relative hidden md:block w-64" data-id="element-298">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-299">
            <Search className="h-4 w-4 text-gray-400" data-id="element-300" />
          </div>
          <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-gray-50 placeholder-gray-500 focus:outline-none focus:bg-white focus:ring-1 focus:ring-[#0B5FA5] focus:border-[#0B5FA5] sm:text-sm transition-colors" placeholder="Search API docs..." data-id="element-301" />
        </div>
        <button className="px-4 py-2 bg-[#0B5FA5] hover:bg-[#1E73BE] text-white text-sm font-medium rounded-lg transition-colors shadow-sm" data-id="element-302">
          Get API Key
        </button>
      </div>
    </header>;
}